import React from "react";
import legsImg from "./../../../../Images/BeautyInnerPages/Legs.png"

const LegsImg = () => {
  return (
    <div className="faceImgContainer">
      <img src={legsImg} alt="legsImg" />
    </div>
  );
};

export default LegsImg;
